import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const savedLanguage = typeof window !== 'undefined' ? window.localStorage.getItem('language') : null

void i18n.use(initReactI18next).init({
  resources: {
    vi: {
      dieuLe: {
        pageTitle: 'Điều lệ | Vietnam Pickleball Awards 2025',
        hero: {
          eyebrow: 'Vietnam Pickleball Awards 2025',
          title: 'Điều lệ đề cử',
          subtitle: 'Điều lệ đề cử & đối tượng áp dụng',
        },
        languageLabel: 'Ngôn ngữ',
        eligibility: {
          title: 'Điều lệ đề cử & đối tượng áp dụng',
          subtitle: 'Điều lệ đề cử & đối tượng áp dụng',
          description:
            'Toàn bộ các hạng mục thuộc Vietnam Pickleball Awards 2025 chỉ áp dụng cho các cá nhân, tập thể và đơn vị có quốc tịch Việt Nam, đồng thời đang hoạt động chính thức tại Việt Nam trong năm xét giải.',
          requirementsTitle: 'Điều kiện bắt buộc bao gồm:',
          points: [
            'Vận động viên pickleball phải có quốc tịch Việt Nam và tham gia thi đấu, tập luyện hoặc hoạt động chuyên môn chính thức tại Việt Nam',
            'Câu lạc bộ, đội nhóm, cộng đồng phải được thành lập và hoạt động tại Việt Nam',
            'Giải đấu, cụm sân, đơn vị tổ chức phải được tổ chức, vận hành và đăng cai tại Việt Nam',
            'Nhà sáng tạo nội dung, nghệ sĩ, người nổi tiếng phải có quốc tịch Việt Nam và tham gia các hoạt động pickleball chính thức tại Việt Nam',
            'Thương hiệu, doanh nghiệp phải đăng ký pháp lý tại Việt Nam và có hoạt động đồng hành pickleball diễn ra tại Việt Nam',
          ],
          ineligibleNotice:
            'Các cá nhân hoặc tổ chức không đáp ứng đồng thời hai điều kiện: (1) quốc tịch Việt Nam và (2) hoạt động chính thức tại Việt Nam sẽ không đủ điều kiện xét đề cử cho bất kỳ hạng mục nào.',
          verificationNotice:
            'Ban Tổ Chức có quyền yêu cầu xác minh quốc tịch, tư cách pháp lý và minh chứng hoạt động thực tế trong quá trình tiếp nhận và xét duyệt hồ sơ đề cử.',
        },
        theLe: {
          title: 'THỂ LỆ',
          subtitle: 'Thể Lệ Bình Chọn và Tính Điểm',
          articles: [
            {
              number: 1,
              title: 'Mục đích của hệ thống bình chọn',
              body: 'Vietnam Pickleball Awards 2025 được tổ chức nhằm tôn vinh những cá nhân, tổ chức và đóng góp nổi bật cho sự phát triển của bộ môn Pickleball tại Việt Nam. Hệ thống bình chọn được thiết kế nhằm đảm bảo các nguyên tắc minh bạch, công bằng và cân bằng giữa đánh giá của cộng đồng và đánh giá chuyên môn.',
            },
            {
              number: 2,
              title: 'Cơ cấu tính điểm chung cuộc',
              body: 'Kết quả của mỗi hạng mục được xác định dựa trên tổng hợp điểm từ ba nguồn:',
              points: [
                'Bình chọn cộng đồng: 50%',
                'Hội đồng Ban Giám khảo: 30%',
                'Hội đồng Chuyên môn: 20%',
              ],
              formula:
                'Điểm Chung Cuộc = (Điểm Cộng Đồng × 50%) + (Điểm Ban Giám Khảo × 30%) + (Điểm Hội Đồng Chuyên Môn × 20%)',
            },
            {
              number: 3,
              title: 'Bình chọn cộng đồng',
              body: 'Bình chọn cộng đồng được thực hiện qua nền tảng Baseline — hệ thống số hóa chính thức do Ban Tổ chức chỉ định. Mỗi tài khoản được 01 lượt bình chọn cho mỗi hạng mục trong chu kỳ 12 giờ. Mỗi hạng mục bao gồm 8 đề cử chính thức sau vòng đề cử. Đề cử có số lượt bình chọn cao nhất được quy đổi thành 100 điểm cộng đồng; các đề cử còn lại quy đổi theo tỷ lệ tương ứng.',
              formula: 'Điểm Cộng Đồng = (Vote của đề cử / Vote cao nhất) × 100',
            },
            {
              number: 4,
              title: 'Hội đồng Ban Giám khảo',
              body: 'Hội đồng Ban Giám khảo gồm 05 thành viên là những cá nhân có uy tín trong lĩnh vực thể thao, truyền thông hoặc cộng đồng pickleball. Mỗi giám khảo chấm điểm độc lập theo thang điểm từ 1 đến 10 cho từng đề cử. Điểm Ban Giám khảo là trung bình cộng của 5 giám khảo.',
              formula:
                'Điểm TB Ban Giám Khảo = (BGK1 + BGK2 + BGK3 + BGK4 + BGK5) / 5\nĐiểm Ban Giám Khảo = Điểm TB Ban Giám Khảo × 10',
            },
            {
              number: 5,
              title: 'Hội đồng Chuyên môn',
              body: 'Hội đồng Chuyên môn gồm 05 thành viên là các chuyên gia pickleball như vận động viên, huấn luyện viên hoặc nhà tổ chức giải đấu. Mỗi thành viên chấm điểm độc lập theo thang điểm từ 1 đến 10. Điểm Hội đồng Chuyên môn được tính bằng trung bình cộng của 5 thành viên.',
              formula:
                'Điểm TB Chuyên Môn = (CM1 + CM2 + CM3 + CM4 + CM5) / 5\nĐiểm Hội Đồng Chuyên Môn = Điểm TB Chuyên Môn × 10',
            },
            {
              number: 6,
              title: 'Xác định kết quả chung cuộc',
              body: 'Sau khi hoàn tất ba thành phần điểm, điểm chung cuộc của mỗi đề cử sẽ được tính theo công thức đã công bố. Đề cử có điểm chung cuộc cao nhất trong mỗi hạng mục sẽ là người chiến thắng.',
            },
            {
              number: 7,
              title: 'Quy tắc xử lý trường hợp bằng điểm',
              body: 'Trong trường hợp hai hoặc nhiều đề cử có điểm chung cuộc bằng nhau, thứ tự ưu tiên xử lý như sau:',
              points: [
                'Ưu tiên đề cử có điểm Ban Giám khảo cao hơn.',
                'Nếu vẫn bằng nhau, xét điểm Hội đồng Chuyên môn.',
                'Nếu vẫn bằng nhau, xét điểm Cộng đồng.',
                'Nếu vẫn bằng nhau, Ban Tổ chức và Chủ tịch Ban Giám khảo quyết định.',
              ],
            },
            {
              number: 8,
              title: 'Quyền quyết định của Ban Tổ chức',
              body: 'Ban Tổ chức có quyền kiểm tra và xác minh tính hợp lệ của các lượt bình chọn. Các lượt bình chọn bất thường hoặc gian lận có thể bị loại bỏ khỏi hệ thống.',
            },
            {
              number: 9,
              title: 'Hiệu lực',
              body: 'Thể lệ này có hiệu lực áp dụng cho toàn bộ quá trình bình chọn và xác định kết quả Vietnam Pickleball Awards 2025.',
            },
            {
              number: 10,
              title: 'Quy chế chống gian lận bình chọn',
              body: 'Ban Tổ chức áp dụng các biện pháp kỹ thuật nhằm phát hiện và ngăn chặn các hành vi gian lận bình chọn, bao gồm nhưng không giới hạn:',
              points: [
                'Sử dụng bot để tạo lượt vote.',
                'Tạo nhiều tài khoản ảo.',
                'Mua lượt vote.',
                'Can thiệp hệ thống bình chọn.',
              ],
              footer:
                'Ban Tổ chức có quyền loại bỏ các lượt vote không hợp lệ và xử lý các trường hợp vi phạm.',
            },
            {
              number: 11,
              title: 'Quy trình kiểm toán kết quả',
              body: 'Toàn bộ dữ liệu bình chọn và chấm điểm sẽ được lưu trữ và kiểm tra để đảm bảo tính minh bạch theo các bước:',
              points: [
                'Tổng hợp dữ liệu vote cộng đồng.',
                'Tổng hợp điểm Ban Giám khảo.',
                'Tổng hợp điểm Hội đồng Chuyên môn.',
                'Chuẩn hóa điểm về thang 100.',
                'Áp dụng công thức tính điểm chung cuộc.',
                'Kiểm tra chéo dữ liệu trước khi công bố kết quả.',
              ],
            },
          ],
        },
        awards: {
          title: 'Vietnam Pickleball Awards 2025',
          subtitle: 'Official Awards Categories',
          groupLabel: 'I. Nhóm giải thưởng chuyên môn (Vận động viên & Thể thao)',
          itemLabel: 'Hạng mục',
          criteriaLabel: 'Tiêu chí',
          items: [
            {
              id: 1,
              title: 'Nam Vận Động Viên Pickleball Xuất Sắc Nhất Của Năm',
              description:
                'Giải thưởng nhằm tôn vinh vận động viên nam pickleball có thành tích thi đấu nổi bật nhất trong năm 2025, thể hiện phong độ ổn định, bản lĩnh thi đấu và tinh thần thể thao chuyên nghiệp, đồng thời đóng góp tích cực cho sự phát triển và hình ảnh của pickleball Việt Nam.',
              criteria: [
                'Thành tích thi đấu chính thức',
                'Thứ hạng & danh hiệu',
                'Phong độ ổn định',
                'Tinh thần thể thao & hình ảnh',
                'Truyền cảm hứng cộng đồng',
              ],
            },
            {
              id: 2,
              title: 'Nữ Vận Động Viên Pickleball Xuất Sắc Nhất Của Năm',
              description:
                'Giải thưởng nhằm vinh danh vận động viên nữ pickleball tiêu biểu trong năm 2025, có thành tích thi đấu nổi bật và đóng vai trò quan trọng trong việc lan tỏa hình ảnh, tinh thần và phong trào pickleball nữ tại Việt Nam.',
              criteria: [
                'Thành tích thi đấu',
                'Đóng góp phong trào',
                'Tinh thần thi đấu & chuyên nghiệp',
                'Hình ảnh & sức ảnh hưởng',
              ],
            },
            {
              id: 3,
              title: 'Đôi VĐV Nam Xuất Sắc Nhất Của Năm',
              description:
                'Giải thưởng tôn vinh đôi vận động viên nam pickleball có thành tích thi đấu xuất sắc trong năm 2025, thể hiện sự gắn kết, phối hợp chiến thuật hiệu quả và tinh thần đồng đội nổi bật, đồng thời đóng góp tích cực cho phong trào pickleball địa phương và quốc gia.',
              criteria: ['Kết quả thi đấu', 'Gắn kết & chiến thuật', 'Đóng góp phong trào'],
            },
            {
              id: 4,
              title: 'Đôi VĐV Nữ Xuất Sắc Nhất Của Năm',
              description:
                'Giải thưởng tôn vinh đôi vận động viên nữ pickleball có thành tích thi đấu nổi bật trong năm 2025, thể hiện tinh thần đoàn kết, phong độ ổn định và hình ảnh tích cực, góp phần lan tỏa phong trào pickleball nữ tại Việt Nam.',
              criteria: [
                'Thành tích bộ đôi',
                'Phát triển & ổn định phong độ',
                'Hình ảnh cộng đồng',
              ],
            },
            {
              id: 5,
              title: 'Đôi VĐV Nam – Nữ Xuất Sắc Nhất Của Năm',
              description:
                'Giải thưởng nhằm vinh danh đôi vận động viên nam – nữ có thành tích nổi bật, thể hiện sự phối hợp ăn ý, chiến thuật hiệu quả và tinh thần đồng đội cao, đại diện cho sự cân bằng và phát triển toàn diện của pickleball Việt Nam.',
              criteria: [
                'Thành tích thi đấu',
                'Phối hợp & chiến thuật',
                'Giá trị hình ảnh & lan tỏa',
              ],
            },
            {
              id: 6,
              title: 'VĐV Nam Trẻ Triển Vọng Của Năm (U18)',
              description:
                'Giải thưởng dành cho vận động viên nam dưới 18 tuổi có bước tiến vượt trội trong năm 2025 và tiềm năng phát triển dài hạn.',
              criteria: [
                'Độ tuổi hợp lệ',
                'Thành tích vượt lứa tuổi',
                'Tiềm năng chuyên môn',
                'Thái độ thi đấu',
              ],
            },
            {
              id: 7,
              title: 'VĐV Nữ Trẻ Triển Vọng Của Năm (U18)',
              description:
                'Giải thưởng tôn vinh vận động viên nữ pickleball trẻ dưới 18 tuổi có bước tiến nổi bật và tiềm năng phát triển bền vững.',
              criteria: [
                'Độ tuổi hợp lệ',
                'Thành tích vượt lứa tuổi',
                'Tiềm năng chuyên môn',
                'Thái độ thi đấu',
              ],
            },
            {
              id: 8,
              title: 'Nam Vận Động Viên Pickleball 40+ Xuất Sắc Nhất Của Năm',
              description:
                'Giải thưởng vinh danh vận động viên nam từ 40 tuổi trở lên có thành tích thi đấu nổi bật, duy trì phong độ bền bỉ, tinh thần thể thao tích cực và đóng vai trò truyền cảm hứng cho cộng đồng pickleball trung niên tại Việt Nam.',
              criteria: [
                'Độ tuổi hợp lệ (40+)',
                'Thành tích thi đấu trong nhóm tuổi hoặc mở rộng',
                'Phong độ và khả năng duy trì thể lực',
                'Tinh thần thể thao và hình ảnh cá nhân',
                'Vai trò truyền cảm hứng cộng đồng',
              ],
            },
            {
              id: 9,
              title: 'Nữ Vận Động Viên Pickleball 40+ Xuất Sắc Nhất Của Năm',
              description:
                'Giải thưởng nhằm tôn vinh vận động viên nữ từ 40 tuổi trở lên có thành tích thi đấu đáng ghi nhận, duy trì đam mê, phong độ ổn định và góp phần lan tỏa tinh thần sống khỏe – tích cực thông qua pickleball.',
              criteria: [
                'Độ tuổi hợp lệ (40+)',
                'Thành tích thi đấu chính thức',
                'Phong độ và sự bền bỉ',
                'Hình ảnh tích cực & tinh thần thể thao',
                'Đóng góp cho cộng đồng người chơi trung niên',
              ],
            },
            {
              id: 10,
              title: 'Câu Lạc Bộ Pickleball Hoạt Động Nổi Bật Của Năm',
              description:
                'Giải thưởng nhằm tôn vinh câu lạc bộ pickleball có hoạt động sôi nổi, tổ chức bài bản và vận hành bền vững, đóng vai trò trung tâm kết nối và phát triển cộng đồng pickleball tại địa phương và trên phạm vi rộng hơn. Giải thưởng ghi nhận năng lực tổ chức, khả năng duy trì phong trào, xây dựng cộng đồng người chơi ổn định, cũng như thành tích thi đấu và hình ảnh tích cực của các thành viên CLB.',
              criteria: [
                'Tần suất & quy mô hoạt động',
                'Đóng góp phong trào địa phương',
                'Số lượng thành viên & giải đấu tổ chức',
                'Hình ảnh & uy tín CLB',
              ],
            },
            {
              id: 11,
              title: 'Giải Thi Đấu Pickleball Của Năm',
              description:
                'Giải thưởng nhằm vinh danh giải đấu pickleball có chất lượng tổ chức xuất sắc, quy mô ấn tượng và sức lan tỏa mạnh mẽ trong nước và quốc tế, góp phần nâng tầm tiêu chuẩn thi đấu và hình ảnh pickleball Việt Nam. Giải thưởng đánh giá toàn diện từ quy mô, chuyên môn, trải nghiệm VĐV đến truyền thông và tác động cộng đồng.',
              criteria: [
                'Quy mô giải đấu',
                'Công tác tổ chức & chuyên môn',
                'Số lượng & chất lượng VĐV',
                'Truyền thông & độ phủ',
              ],
            },
            {
              id: 12,
              title: 'Cụm Sân Pickleball Của Năm',
              description:
                'Giải thưởng nhằm tôn vinh cụm sân pickleball đạt tiêu chuẩn tổ chức các giải đấu quy mô lớn, chuyên nghiệp và tiệm cận chuẩn quốc tế, có khả năng đăng cai giải đấu cấp quốc gia – khu vực – quốc tế, đồng thời đóng vai trò hạ tầng chiến lược cho sự phát triển lâu dài của pickleball Việt Nam.',
              criteria: [
                'Chất lượng sân bãi & dịch vụ',
                'Tần suất & hiệu suất hoạt động',
                'Đóng góp cho cộng đồng',
              ],
            },
            {
              id: 13,
              title: 'Cộng Đồng Truyền Thông Pickleball Của Năm',
              description:
                'Giải thưởng nhằm vinh danh cộng đồng truyền thông pickleball có vai trò lan tỏa thông tin chính xác, kiến thức giá trị và tinh thần thể thao tích cực, đồng thời kết nối cộng đồng người chơi một cách bền vững.',
              criteria: ['Quy mô & tương tác', 'Nội dung tích cực, giá trị', 'Ảnh hưởng cộng đồng'],
            },
            {
              id: 14,
              title: 'CLB Hoạt Động Social Play Của Năm',
              description:
                'Giải thưởng tôn vinh CLB pickleball thúc đẩy mạnh mẽ phong trào social play, tạo môi trường chơi thân thiện, mở rộng cộng đồng người chơi mới và đề cao sức khỏe – kết nối – niềm vui.',
              criteria: ['Tần suất social play', 'Mở rộng cộng đồng', 'Tính thân thiện & kết nối'],
            },
            {
              id: 15,
              title: 'Nhà Sáng Tạo Nội Dung Pickleball Của Năm',
              description:
                'Giải thưởng nhằm tôn vinh cá nhân hoặc đơn vị sáng tạo nội dung có đóng góp nổi bật trong việc định hình hình ảnh, kiến thức và cảm hứng pickleball Việt Nam trên các nền tảng truyền thông.',
              criteria: ['Chất lượng & sáng tạo', 'Tiếp cận & tương tác', 'Đóng góp cộng đồng'],
            },
            {
              id: 16,
              title: 'Nam Nghệ Sĩ / Người Nổi Tiếng Hoạt Động Pickleball Nổi Bật Của Năm',
              description:
                'Giải thưởng nhằm vinh danh nghệ sĩ hoặc người nổi tiếng có sức ảnh hưởng xã hội, tham gia pickleball nghiêm túc và bền bỉ, góp phần đưa pickleball đến công chúng đại chúng.',
              criteria: ['Mức độ tham gia', 'Ảnh hưởng truyền thông', 'Lan tỏa phong trào'],
            },
            {
              id: 17,
              title: 'Nữ Nghệ Sĩ / Người Nổi Tiếng Hoạt Động Pickleball Nổi Bật Của Năm',
              description:
                'Giải thưởng nhằm vinh danh nghệ sĩ hoặc người nổi tiếng có sức ảnh hưởng xã hội, tham gia pickleball nghiêm túc và bền bỉ, góp phần đưa pickleball đến công chúng đại chúng.',
              criteria: ['Mức độ tham gia', 'Ảnh hưởng truyền thông', 'Lan tỏa phong trào'],
            },
            {
              id: 18,
              title: 'Thương Hiệu Đồng Hành Xây Dựng & Phát Triển Pickleball Của Năm',
              description:
                'Giải thưởng nhằm vinh danh thương hiệu hoặc doanh nghiệp có đóng góp dài hạn, chiến lược và có chiều sâu, đồng hành phát triển hệ sinh thái pickleball Việt Nam.',
              criteria: ['Mức độ đầu tư & đồng hành', 'Tính bền vững', 'Tác động thực tế'],
            },
          ],
        },
      },
    },
    en: {
      dieuLe: {
        pageTitle: 'Rules | Vietnam Pickleball Awards 2025',
        hero: {
          eyebrow: 'Vietnam Pickleball Awards 2025',
          title: 'Nomination Rules',
          subtitle: 'Nomination eligibility & nationality requirement',
        },
        languageLabel: 'Language',
        eligibility: {
          title: 'Nomination Eligibility & Nationality Requirement',
          subtitle: 'Nomination Eligibility & Nationality Requirement',
          description:
            'All award categories of Vietnam Pickleball Awards 2025 are strictly limited to individuals, teams, and organizations holding Vietnamese nationality AND officially operating in Vietnam during the award year.',
          requirementsTitle: 'Mandatory eligibility requirements include:',
          points: [
            'Pickleball athletes must hold Vietnamese nationality and be actively competing, training, or officially participating in pickleball activities in Vietnam',
            'Clubs, teams, and communities must be legally established and operating in Vietnam',
            'Tournaments, venues, and organizing entities must be hosted, operated, and conducted within Vietnam',
            'Content creators, artists, and public figures must hold Vietnamese nationality and have official pickleball activities in Vietnam',
            'Brands and corporations must be legally registered in Vietnam and have active pickleball-related partnerships or projects within Vietnam',
          ],
          ineligibleNotice:
            'Any individual or organization that does not simultaneously meet both conditions—(1) Vietnamese nationality AND (2) official activity in Vietnam—shall be deemed ineligible for nomination in any award category.',
          verificationNotice:
            'The Organizing Committee reserves the right to verify nationality, legal status, and documented proof of official activities in Vietnam throughout the nomination and evaluation process.',
        },
        theLe: {
          title: 'RULES',
          subtitle: 'Voting & Scoring Regulations',
          articles: [
            {
              number: 1,
              title: 'Purpose of the Voting System',
              body: 'Vietnam Pickleball Awards 2025 is organized to honor individuals, organizations, and outstanding contributions to the development of Pickleball in Vietnam. The voting system is designed to ensure transparency, fairness, and balance between community evaluation and expert assessment.',
            },
            {
              number: 2,
              title: 'Overall Scoring Structure',
              body: 'The result of each category is determined based on a combined score from three sources:',
              points: [
                'Community voting: 50%',
                'Judging Panel: 30%',
                'Technical & Professional Council: 20%',
              ],
              formula:
                'Final Score = (Community Score × 50%) + (Jury Score × 30%) + (Expert Score × 20%)',
            },
            {
              number: 3,
              title: 'Community Voting',
              body: 'Community voting is conducted through the Baseline platform — the official digital system designated by the Organizing Committee. Each account may cast 1 vote per category per 12-hour cycle. Each category includes 8 official nominees after the nomination round. The nominee with the highest votes converts to 100 community points; remaining nominees are scaled proportionally.',
              formula: 'Community Score = (Nominee votes / Highest votes) × 100',
            },
            {
              number: 4,
              title: 'Judging Panel',
              body: 'The Judging Panel consists of 5 members who are reputable individuals in sports, media, or the pickleball community. Each judge scores independently on a scale of 1 to 10 for each nominee. The Jury score is the average of all 5 judges.',
              formula:
                'Avg Jury Score = (J1 + J2 + J3 + J4 + J5) / 5\nJury Score = Avg Jury Score × 10',
            },
            {
              number: 5,
              title: 'Technical & Professional Council',
              body: 'The Expert Council consists of 5 members who are pickleball specialists such as athletes, coaches, or tournament organizers. Each member scores independently on a scale of 1 to 10. The Expert score is the average of all 5 members.',
              formula:
                'Avg Expert Score = (E1 + E2 + E3 + E4 + E5) / 5\nExpert Score = Avg Expert Score × 10',
            },
            {
              number: 6,
              title: 'Determining the Final Result',
              body: 'After all three scoring components are finalized, the overall score for each nominee is calculated according to the published formula. The nominee with the highest overall score in each category is the winner.',
            },
            {
              number: 7,
              title: 'Tie-Breaking Rules',
              body: 'In the event that two or more nominees have equal overall scores, the following priority order applies:',
              points: [
                'Priority goes to the nominee with the higher Jury score.',
                'If still tied, the Expert Council score is considered.',
                'If still tied, the Community vote is considered.',
                'If still tied, the Organizing Committee and Jury Chairman will decide.',
              ],
            },
            {
              number: 8,
              title: "Organizing Committee's Authority",
              body: 'The Organizing Committee has the right to review and verify the validity of all votes. Irregular or fraudulent votes may be removed from the system.',
            },
            {
              number: 9,
              title: 'Validity',
              body: 'These regulations are effective for the entire voting and result-determination process of Vietnam Pickleball Awards 2025.',
            },
            {
              number: 10,
              title: 'Anti-Fraud Policy',
              body: 'The Organizing Committee applies technical measures to detect and prevent voting fraud, including but not limited to:',
              points: [
                'Using bots to generate votes.',
                'Creating multiple fake accounts.',
                'Purchasing votes.',
                'Interfering with the voting system.',
              ],
              footer:
                'The Organizing Committee reserves the right to remove invalid votes and take action against violations.',
            },
            {
              number: 11,
              title: 'Result Audit Process',
              body: 'All voting and scoring data will be stored and reviewed to ensure transparency through the following steps:',
              points: [
                'Aggregating community vote data.',
                'Aggregating Jury scores.',
                'Aggregating Expert Council scores.',
                'Normalizing scores to a 100-point scale.',
                'Applying the final scoring formula.',
                'Cross-checking data before announcing results.',
              ],
            },
          ],
        },
        awards: {
          title: 'Vietnam Pickleball Awards 2025',
          subtitle: 'Official Awards Categories',
          groupLabel: 'I. Professional Awards (Athletes & Competition)',
          itemLabel: 'Category',
          criteriaLabel: 'Criteria',
          items: [
            {
              id: 1,
              title: 'Men’s Pickleball Player of the Year',
              description:
                'This award honors the male pickleball athlete with the most outstanding competitive achievements in 2025, demonstrating consistent performance, competitive excellence, and professional sportsmanship, while making significant contributions to the development and image of pickleball in Vietnam.',
              criteria: [
                'Official tournament results',
                'Rankings and titles achieved',
                'Performance consistency',
                'Sportsmanship and positive image',
                'Inspiration to the pickleball community',
              ],
            },
            {
              id: 2,
              title: 'Women’s Pickleball Player of the Year',
              description:
                'This award recognizes an outstanding female pickleball athlete in 2025, distinguished by exceptional competitive performance and a significant role in promoting women’s pickleball in Vietnam.',
              criteria: [
                'Competitive achievements',
                'Contribution to tournaments and community',
                'Professional attitude and sportsmanship',
                'Positive image and community influence',
              ],
            },
            {
              id: 3,
              title: 'Men’s Doubles Team of the Year',
              description:
                'This award honors the men’s doubles team with outstanding competitive results in 2025, demonstrating strong teamwork, effective tactics, and meaningful contributions to pickleball development at both local and national levels.',
              criteria: [
                'Official match results',
                'Teamwork and tactical effectiveness',
                'Contribution to pickleball development',
              ],
            },
            {
              id: 4,
              title: 'Women’s Doubles Team of the Year',
              description:
                'This award recognizes a women’s doubles team with outstanding performance in 2025, showcasing unity, consistent form, and a positive role in promoting women’s pickleball in Vietnam.',
              criteria: [
                'Team achievements',
                'Development and consistency',
                'Positive community image',
              ],
            },
            {
              id: 5,
              title: 'Mixed Doubles Team of the Year',
              description:
                'This award honors a mixed doubles team with outstanding results, demonstrating strong coordination, tactical efficiency, and representing balanced and inclusive development of pickleball in Vietnam.',
              criteria: [
                'Competitive results',
                'Coordination and tactics',
                'Representation and positive influence',
              ],
            },
            {
              id: 6,
              title: 'Men’s Young Prospect of the Year',
              description:
                'This award recognizes a male athlete under 18 with remarkable progress in 2025 and strong long-term development potential.',
              criteria: [
                'Age eligibility',
                'Age-level achievements',
                'Technical potential',
                'Training and competition attitude',
              ],
            },
            {
              id: 7,
              title: 'Women’s Young Prospect of the Year',
              description:
                'This award honors a female pickleball athlete under 18 who has shown significant improvement and strong long-term potential.',
              criteria: [
                'Age eligibility',
                'Age-level achievements',
                'Technical potential',
                'Training and competition attitude',
              ],
            },
            {
              id: 8,
              title: 'Men’s Pickleball 40+ Player of the Year',
              description:
                'This award honors a male pickleball athlete aged 40 and above who demonstrates outstanding performance, longevity, sportsmanship, and inspirational community impact.',
              criteria: [
                'Age eligibility (40+)',
                'Competitive results within age group or open events',
                'Performance consistency and fitness longevity',
                'Sportsmanship and personal image',
                'Inspirational community role',
              ],
            },
            {
              id: 9,
              title: 'Women’s Pickleball 40+ Player of the Year',
              description:
                'This award recognizes a female pickleball athlete aged 40 and above with notable achievements, consistent performance, and positive advocacy for active lifestyles.',
              criteria: [
                'Age eligibility (40+)',
                'Official competitive achievements',
                'Consistency and endurance',
                'Positive image and sportsmanship',
                'Contribution to the 40+ player community',
              ],
            },
            {
              id: 10,
              title: 'Pickleball Club of the Year',
              description:
                'This award recognizes a pickleball club with outstanding organizational activities, sustainable operations, and a central role in developing local and national pickleball communities. The award honors not only competitive results, but also community building, operational excellence, and positive club culture.',
              criteria: [
                'Activity frequency and scale',
                'Contribution to local development',
                'Membership size and tournaments hosted',
                'Club image and reputation',
              ],
            },
            {
              id: 11,
              title: 'Pickleball Tournament of the Year',
              description:
                'This award honors a pickleball tournament with exceptional organizational quality, impressive scale, and strong national or international impact, contributing to elevating Vietnam’s competitive standards.',
              criteria: [
                'Tournament scale',
                'Organization and technical standards',
                'Number and quality of athletes',
                'Media exposure and community reach',
              ],
            },
            {
              id: 12,
              title: 'Pickleball Venue of the Year',
              description:
                'This award recognizes a pickleball venue capable of hosting large-scale, professional, and international-level tournaments, serving as a strategic infrastructure hub for long-term pickleball development.',
              criteria: [
                'Court quality and services',
                'Operational frequency',
                'Contribution to players and ecosystem',
              ],
            },
            {
              id: 13,
              title: 'Pickleball Media Community of the Year',
              description:
                'This award honors a media community that effectively spreads knowledge, positive values, and connects pickleball players through responsible and impactful communication.',
              criteria: [
                'Community size and engagement',
                'Quality and positivity of content',
                'Community influence',
              ],
            },
            {
              id: 14,
              title: 'Social Play Club of the Year',
              description:
                'This award recognizes a club that actively promotes social play, inclusivity, wellness, and community bonding, beyond competitive performance.',
              criteria: [
                'Frequency of social play',
                'Community growth',
                'Inclusiveness and friendliness',
              ],
            },
            {
              id: 15,
              title: 'Pickleball Content Creator of the Year',
              description:
                'This award honors a content creator or organization that significantly contributes to shaping pickleball awareness, education, and inspiration.',
              criteria: [
                'Content quality and creativity',
                'Reach and engagement',
                'Community contribution',
              ],
            },
            {
              id: 16,
              title: 'Male Celebrity Pickleball Advocate of the Year',
              description:
                'This award honors celebrities who actively and authentically participate in pickleball, using their influence to expand public awareness and community engagement.',
              criteria: ['Level of participation', 'Media influence', 'Positive advocacy'],
            },
            {
              id: 17,
              title: 'Female Celebrity Pickleball Advocate of the Year',
              description:
                'This award honors celebrities who actively and authentically participate in pickleball, using their influence to expand public awareness and community engagement.',
              criteria: ['Level of participation', 'Media influence', 'Positive advocacy'],
            },
            {
              id: 18,
              title: 'Pickleball Development Partner of the Year',
              description:
                'This award recognizes a brand or corporation with long-term strategic commitment and meaningful impact on Vietnam’s pickleball ecosystem.',
              criteria: [
                'Level of investment and partnership',
                'Sustainability of commitment',
                'Real ecosystem impact',
              ],
            },
          ],
        },
      },
    },
  },
  fallbackLng: 'vi',
  lng: savedLanguage ?? 'vi',
  ns: ['dieuLe'],
  defaultNS: 'dieuLe',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
